<template>
  <div class="page product-detail" v-if="product">
    <p class="breadcrumb"><a href="/products.html">匠心产品</a> / {{ product.title }}</p>
    <h1>{{ product.title }}</h1>
    <div class="detail-body">
      <img class="product-image" :src="product.image" :alt="product.title" width="480" height="360">
      <div class="detail-copy">
        <p class="page-intro">{{ product.description }}</p>
        <ContactFriend placement="hero" />
        <h2>产品特点</h2>
        <ul>
          <li v-for="(feature, index) in product.features" :key="index">{{ feature }}</li>
        </ul>
        <h2>食用方法</h2>
        <p>{{ product.usage }}</p>
        <p class="packaging-note">{{ product.packagingNote }}</p>
        <p><a href="/products.html">返回全部产品</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { findProductById, showcasedProductIds } from '@/config/products';
import ContactFriend from '@/components/ContactFriend.vue';

export default {
  name: 'ProductDetailPage',
  components: {
    ContactFriend
  },
  computed: {
    product() {
      const id = this.$route.params.id;
      return showcasedProductIds.includes(id) ? findProductById(id) : null;
    }
  }
}
</script>

<style scoped>
.page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

.breadcrumb {
  color: #666;
  font-size: 0.9em;
  margin: 0 0 8px;
}

.breadcrumb a {
  color: #4b0082;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 12px;
}

h2 {
  color: #4b0082;
  font-size: 1.1em;
  margin: 20px 0 6px;
}

.detail-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.product-image {
  max-width: 100%;
  height: auto;
  border-radius: 16px;
  background: #f5f0ff;
}

.page-intro,
li,
p {
  color: #333;
  line-height: 1.8;
}

ul {
  padding-left: 18px;
  margin: 0;
}

.packaging-note {
  color: #666;
  font-size: 0.95em;
}

@media (min-width: 769px) {
  .detail-body {
    flex-direction: row;
    align-items: flex-start;
  }

  .product-image {
    width: 46%;
  }

  .detail-copy {
    flex: 1;
  }
}
</style>
